import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LoanResponse } from '@impact/data';
import { first } from 'rxjs/operators';

import { CheckoutService } from '../../../../../checkout/checkout.service';

@Component({
    selector: 'app-checkout-step-payment-loan',
    template: `
        <section class="flow-step__section-block" *ngIf="checkoutService.getCheckoutData() | async as cd">
            <header class="flow-step__section-block-header">
                <h5>{{ 'checkout.payment_step____loan____headline' | translate }}</h5>
                <p>{{ 'checkout.payment_step____loan____description' | translate }}</p>
            </header>
            <app-checkout-price-calculation-summary
                [loanAmount]="loanAmount"
                [outstandingDebt]="outstandingDebt"
                (handleOutstandingDebt)="handleDebt($event)"
                [priceTranslation]="'checkout.payment_step____loan____calculated_loan_amount' | translate"
            ></app-checkout-price-calculation-summary>
        </section>

        <section class="flow-step__section-block" *ngIf="checkoutService.getCheckoutData() | async as cd">
            <app-loan
                [loanAmount]="loanAmount"
                [paymentTerms]="loanData?.paymentTerms || cd.loan?.paymentTerms"
                [downPaymentPct]="loanData?.downPaymentPct || cd.loan?.downPaymentPct"
                [interestType]="loanData?.interestType || cd.loan?.interestType"
            ></app-loan>
        </section>

        <app-loan-details [showCompleteButton]="true"></app-loan-details>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutStepPaymentLoanComponent {
    @Input() loanData?: LoanResponse;
    loanAmount: number;
    outstandingDebt = 0;
    constructor(public checkoutService: CheckoutService) {
        this.calcLoan();
    }

    handleDebt(value: string) {
        const val = parseInt(value);
        const debtValue = isNaN(val) ? 0 : val;

        this.calcLoan(debtValue);
        this.outstandingDebt = debtValue;
    }

    calcLoan(outstandingDebt?: number) {
        this.checkoutService
            .getCheckoutData()
            .pipe(first())
            .subscribe(({ product, exchangeCar }) => {
                this.loanAmount = (product?.grossPrice || 0) - (exchangeCar?.price || 0) + (outstandingDebt || 0);
            });
    }
}
